import React from 'react';
import componentMap from '../../../../../utils/componentMap';
import Default from './types/Default';
import Table from './types/Table';

const Panel = (props) => {
  const Component = componentMap(props, {
    table: Table,
    default: Default,
  })

  return (
    <Component {...props} />
  );
}

export default Panel;